import { render } from "./SlidePreviewTitle.vue?vue&type=template&id=d2322446&scoped=true"
import script from "./SlidePreviewTitle.vue?vue&type=script&lang=js"
export * from "./SlidePreviewTitle.vue?vue&type=script&lang=js"

import "./SlidePreviewTitle.vue?vue&type=style&index=0&id=d2322446&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2322446"]])

export default __exports__